import {getAllNumberSetting} from '../../services/NumberSettingServices'

const VOUCHER_TYPE_OPTIONS_RAW = [
    { value: 'sales_order', label: 'Sales Order' },
    { value: 'delivery_challan', label: 'Delivery Challan' },
    { value: 'cube_test_report', label: 'Cube Test Report' },
    { value: 'invoice', label: 'Invoice' },
    { value: 'receipt_voucher', label: 'Receipt' },
    { value: 'credit_note', label: 'Credit Note' },
    { value: 'debit_note', label: 'Debit Note' },
    { value: 'general_journal_voucher', label: 'General Journal' },
    { value: 'quotation', label: 'Quotation' },
    { value: 'concrete_estimator', label: 'Concrete Estimator' },
    { value: 'purchase_order', label: 'Purchase Order' },
    { value: 'goods_reciept_note', label: 'Goods Receipt Note' },
    { value: 'consumption_note', label: 'Consumption Note' },
    { value: 'diesel_consumption_note', label: 'Diesel Consumption Note' },
];

export const VOUCHER_TYPE_OPTIONS = [...VOUCHER_TYPE_OPTIONS_RAW].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
);

export function getVoucherTypeLabel(voucherType) {
    return VOUCHER_TYPE_OPTIONS.find((item) => item.value === voucherType)?.label
        || String(voucherType || '').replace(/_/g, ' ');
}

export function checkForDuplicateNumberSettings(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllNumberSetting(cookies)
      .then((data) => {

        let isUserExists = false;
        for(var i=0; i<data.salesrep_data.length; i++)    //Same Sales Representative Name mentioned it denoted already exist.
        {
          if((data.salesrep_data[i].entity_name) === value.trim().toUpperCase()
            && parseInt(existingId) !== data.salesrep_data[i].id){   
            
            console.log(`User exists with the name - ${value}`) 
            isUserExists = true;
            break;
          }
        }
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }